import vSelect from 'vue-select';
import codes from '@/codes';
import config from '../../../config';
import moment from 'moment-timezone';
import { VclFacebook } from 'vue-content-loading';

//restful api
//dashboard
import { dashboard as main_dashboard } from '@/service/api/integrity';
import { dashboard as wmds_dashboard } from '@/service/api/wmds';
import { dashboard as wsfinder_dashboard } from '@/service/api/wsfinder';
import { dashboard as webcastle_dashboard } from '@/service/api/webcastle';

//log
import { loginLog } from '@/service/api/log'

//manager
import { group, partner, user } from '@/service/api/manager'

//billing - subscription
import { sub } from '@/service/api/billing'

const i18n_name = {
  user : {
    EN : `User Login`,
    KO : `사용자 로그인`
  },
  partner : {
    EN : `Partner Login`,
    KO : `파트너 로그인`
  },
  admin : {
    EN : `Admin Login`,
    KO : `관리자 로그인`
  }
}

export default {
  components : { vSelect, VclFacebook, },
  computed: {
      f_detect() {
        return [
        { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 10%' },
        { key: 'remote_addr', label: 'Attack', sortable: false, thStyle: 'width: 10%' },
        { key: 'target', label: 'Target', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 10%' },
        { key: 'request', label: 'Request', sortable: false },
      ]
    },
    i18n_name() {
      return i18n_name
    }
  },
  data: () => {
    return {
      loading_1 : false,
      loading_2 : false,
      loading_3 : false,
      codes,
      // new var
      chart_circle : {
        service_count : 0,
        service_data : [],
        price_count : 0,
        price_data : [],
      },
      // old var
      config,
      level_list: ['user', 'manager', 'owner', 'master'],
      month_list : [],
      year_list : [],
      option : { all : true, year : (new Date()).year, month : (new Date()).month },
      model : {
        login: [],
        login_option: [
          { title: {
              display: true,
              text: 'Custom Chart Title'
            }
          },
          { legend: {
              display: true,
              labels: { fontColor: 'rgb(255, 99, 132)' }
            }
          }
        ],
        subscription : { total : 0, list : [] },
        user : { total : 0, disable : 0, enable : 0 },
        partner : { total : 0, disable : 0, enable : 0 },
        group : { total : 0, disable : 0, enable : 0 },

        // 탐지 : dt , 결과, 차단 : pg
        // today : dt_d, pg_d , yesterday : dt_d_yesterday, pg_d_yesterday
        wmds : { summary : {}, result : { pg_d : 0, pg_d_yesterday : 0, gap : 0 }, detect : { dt_d : 0, dt_d_yesterday : 0, gap : 0 } },
        wsfinder : { summary : {}, result : { pg_d : 0, pg_d_yesterday : 0, gap : 0 }, detect : { dt_d : 0, dt_d_yesterday : 0, gap : 0 } },
        webcastle : { summary : {}, result : { pg_d : 0, pg_d_yesterday : 0, gap : 0 }, detect : { dt_d : 0, dt_d_yesterday : 0, gap : 0 } },
        forgery : { summary : {}, wmds : { pg_d : 0, pg_d_yesterday : 0, gap : 0 }, wsfinder : { dt_d : 0, dt_d_yesterday : 0, gap : 0 } },

        //dashboard date
        start_at : moment().startOf('d')
      },
      sync : { interval : 60, stop : false, th : undefined },
      flag_stop : false,
    }
  },
  methods: {
    NumberToStr(x) { return `${x}` },
    build_date() {
      let now = new Date
      for (let i = now.getFullYear(); i >= this.config.startYear; i--) { this.year_list.push(`${i}`) }
      for (let i = 1; i <= 12; i++) { this.month_list.push(`${i}`) }
      // load default value
      this.option  = Object.assign(this.option, { year : this.NumberToStr(now.getFullYear()), month : this.NumberToStr(now.getMonth() + 1) })
      this.model.wmds = Object.assign(this.model.wmds, this.option);
      this.model.webcastle = Object.assign(this.model.webcastle, this.option);
      this.model.wsfinder = Object.assign(this.model.wsfinder, this.option);
      this.model.forgery = Object.assign(this.model.forgery, this.option);
      this.model.forgery.wsfinder = this.model.forgery.wsfinder;
      this.model.forgery.wmds = this.model.forgery.wmds;
      // check caching
    },
    realTime_dashboard(){
      if(this.sync.th){ //clearTimeout
        clearTimeout(this.sync.th);
        this.sync.th = undefined;
      }

      if(!this.sync.th) { //setTimeout
        // 1분에 한번씩 요청하게 세팅
        this.sync.th = setTimeout(this.reload, this.sync.interval * 1000);
      }

      wmds_dashboard.allDashboard({ start_at : this.model.start_at }).then(rs => {
        if(!rs.body) { return; }
        this.model.wmds.summary = rs.body.usage.data ? rs.body.usage.data : undefined;
        this.model.wmds.summary = Object.assign({}, this.model.wmds.summary, { enable : this.model.wmds.summary.total - this.model.wmds.summary.disable })
        this.model.wmds.result = rs.body.result
        this.model.wmds.detect = rs.body.detect

        this.model.wmds.result.gap = this.model.wmds.result.pg_d - this.model.wmds.result.pg_d_yesterday
        this.model.wmds.detect.gap = this.model.wmds.detect.dt_d - this.model.wmds.detect.dt_d_yesterday
      }).catch(e => { console.log('wmds', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

      wsfinder_dashboard.allDashboard({ start_at : this.model.start_at }).then(rs => {
        if(!rs.body) { return; }
        this.model.wsfinder.summary = rs.body.usage.data ? rs.body.usage.data : undefined;
        this.model.wsfinder.summary = Object.assign({}, this.model.wsfinder.summary, { enable : this.model.wsfinder.summary.total - this.model.wsfinder.summary.disable })
        this.model.wsfinder.result = rs.body.result
        this.model.wsfinder.detect = rs.body.detect

        this.model.wsfinder.result.gap = this.model.wsfinder.result.pg_d - this.model.wsfinder.result.pg_d_yesterday
        this.model.wsfinder.detect.gap = this.model.wsfinder.detect.dt_d - this.model.wsfinder.detect.dt_d_yesterday
      }).catch(e => { console.log('wsfinder', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

      webcastle_dashboard.allDashboard({ start_at : this.model.start_at }).then(rs => {
        if(!rs.body) { return; }
        this.model.webcastle.summary = rs.body.usage.data ? rs.body.usage.data : undefined;
        this.model.webcastle.summary = Object.assign({}, this.model.webcastle.summary, { enable : this.model.webcastle.summary.total - this.model.webcastle.summary.disable })
        this.model.webcastle.result = rs.body.result
        this.model.webcastle.detect = rs.body.detect

        this.model.webcastle.result.gap = this.model.webcastle.result.pg_d - this.model.webcastle.result.pg_d_yesterday
        this.model.webcastle.detect.gap = this.model.webcastle.detect.dt_d - this.model.webcastle.detect.dt_d_yesterday

        this.loading_2 = false // 전체 로딩 확인 후 async/await 처리해야 하나, 가장 데이터가 많은 웹캐슬 기준으로 함
      }).catch(e => { console.log('webcastle', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

      main_dashboard.allDashboard({ start_at : this.model.start_at }).then(rs => {
        if(!rs.body) { return; }
        let summary = rs.body.usage.data ? rs.body.usage.data : undefined;

        if(summary) {
          this.model.forgery.summary = {
            wsfinder : summary.wsfinder.total,
            wmds : summary.wmds.total,
            total : summary.wsfinder.total + summary.wmds.total,
            disable  : 0
          }
        }
        this.model.forgery.wsfinder = rs.body.wsfinder;
        this.model.forgery.wmds = rs.body.wmds;

        this.model.forgery.wsfinder.gap = this.model.forgery.wsfinder.dt_d - this.model.forgery.wsfinder.dt_d_yesterday
        this.model.forgery.wmds.gap = this.model.forgery.wmds.pg_d - this.model.forgery.wmds.pg_d_yesterday
      }).catch(e => { console.log('integrity', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});
    },
    load() {
      try {
        this.loading_1 = this.loading_2 = this.loading_3 = true

        this.realTime_dashboard();  //실시간 고려

        group.summaryGroup().then(rs => {
          if(!rs.body) { return; }

          this.model = Object.assign({}, this.model, { group : rs.body })
          this.model.group.total = this.model.group.disable + this.model.group.enable
        }).catch(e => { console.log('group', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        partner.summaryPartner({id: this.model.id}).then(rs => {
          if(!rs.body) { return; }

          this.model = Object.assign({}, this.model, { partner : rs.body })
          this.model.partner.total = this.model.partner.disable + this.model.partner.enable
        }).catch(e => { console.log('partner', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        user.summaryUser().then(rs => {
          if(!rs.body) { return; }

          this.model = Object.assign({}, this.model, { user : rs.body })
          this.model.user.total = this.model.user.disable + this.model.user.enable
        }).catch(e => { console.log('user', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        sub.summarySub().then(rs => {
          if(!rs.body) { return; }
          this.model.subscription = Object.assign({}, this.model.subscription, { list : rs.body, total : _.sumBy(rs.body, x => x.total) })
          this.loading_3 = false
        }).catch(e => { console.log('subscription', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

        this.loading_1 = true
        this.model.login = []

        loginLog.dashboardLog({ ts : new Date().getTime() }).then(rs => {
          if(!rs.body || rs.body.length < 1) { return; }
          this.model.login.push({
            name : `${this.i18n_name['user'][this.i18n]}`,
            data : _.map(rs.body.user, r => [moment(r.date).format('MM-DD'), r.cnt])
          })

          this.model.login.push({
            name : `${this.i18n_name['partner'][this.i18n]}`,
            data : _.map(rs.body.partner, r => [moment(r.date).format('MM-DD'), r.cnt])
          })

          this.model.login.push({
            name : `${this.i18n_name['admin'][this.i18n]}`,
            data : _.map(rs.body.admin, r => [moment(r.date).format('MM-DD'), r.cnt])
          })

          this.loading_1 = false
        }).catch(e => { console.log('log.login', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});

      } catch (e) { console.log(e); this.$toastr.e("Dashboard", 'load failed') }
    },
    reload(){
      if(!this.sync.stop && !this.flag_stop) {
        this.realTime_dashboard();
        console.log('Dashboard refresh', new Date());
      }
    },
  },
  created () {
    console.log('dashboard.i18.vue created');
    this.build_date()
  },
  mounted () {
    console.log('dashboard.i18.vue mounted');
    this.load()
  },
  destroyed () {
    this.sync.th = undefined;
    this.flag_stop = true;
    console.log('dashboard18n.vue destroyed');
  },
}